<template>
  <div style="display: flex;">
    <div class="left_menu_container">
      <div>
        <div style="clear:both;height:34px;"></div>
        <div style="text-align: left;padding-left: 30px;">
          <div class="logo"></div>
          <div class="title"
               v-if="!collapse">弈&nbsp;写</div>
        </div>

        <div style="clear:both;height:34px;"></div>
        <el-menu :default-active="menuActiveIndex"
                 @select="handleSelect"
                 :collapse="collapse"
                 class="t_l"
                 :collapse-transition="false">

          <template v-if="type === 'setting'">
            <el-menu-item index="/userInfo">
              <i class="menu_item userInfo"></i>
              <span slot="title">
                个人设置
              </span>
            </el-menu-item>
            <el-menu-item index="/orders">
              <i class="menu_item orders"></i>
              <span slot="title">
                购买记录
              </span>
            </el-menu-item>
            <el-menu-item index="/invoice">
              <i class="menu_item invoice"></i>
              <span slot="title">
                发票管理
              </span>
            </el-menu-item>
          </template>
          <template v-else>
            <el-menu-item index="/">
              <i class="menu_item ai_writer"></i>
              <span slot="title">
                AI写作
              </span>
            </el-menu-item>
            <el-menu-item index="/chat">
              <i class="menu_item ai_chat"></i>
              <span slot="title">
                弈Chat<span class="menu-test"></span>
              </span>

            </el-menu-item>

            <el-menu-item index="/articles">
              <i class="menu_item articles"></i>
              <span slot="title">
                我的文章库
              </span>

            </el-menu-item>

            <el-menu-item index="/material">
              <i class="menu_item material"></i>
              <span slot="title">
                我的素材库
              </span>

            </el-menu-item>

            <el-menu-item index="/recycle">
              <i class="menu_item recycle"></i>
              <span slot="title">
                我的回收站
              </span>

            </el-menu-item>
          </template>
        </el-menu>

        <template v-if="type === 'setting'">
          <a href="javascript:void(0)">
            <div class="goHome"
                 @click="to('/')">
              返回首页
            </div>
          </a>
        </template>
        <template v-else>
          <div class="userInfoContainer"
               v-if="userInfo && userInfo.id">
            <el-popover placement="top-end"
                        title=""
                        :width="200"
                        trigger="click"
                        popper-class="userInfoCard"
                        :offset="200">
              <div>
                <div :class="'vip_card vip_card_' + vipInfo.vipLevel">
                  <div class="avatar"> <el-avatar :size="48"
                               :src="userInfo.headPath"
                               class="defaultAvatar"></el-avatar>
                  </div>
                  <div class="info">
                    <div class="nickNmae">{{ userInfo.nickname }}</div>
                    <div :class="'vip vip_' + vipInfo.vipLevel"></div>
                  </div>
                  <a href="javascript:void(0)"
                     style="    text-decoration: none;">
                    <div class="endDate"
                         @click="toBuy()">
                      <el-row>
                        <template v-if="vipInfo.vipInfo === 'NORMAL'">
                          解锁更多权益&nbsp;&gt;
                        </template>
                        <template v-else>
                          <el-col :span="14">
                            {{ vipInfo.vipEndDate }}到期
                          </el-col>
                          <el-col :span="10"
                                  class="t_r">续费&nbsp;&gt;&nbsp;</el-col>
                        </template>
                      </el-row>
                    </div>
                  </a>
                </div>

                <div class="item"> <el-link :underline="false"
                           @click="to('/userInfo')">个人设置 </el-link></div>

                <div class="item"> <el-link :underline="false"
                           href="/help.html"
                           target="_blank">帮助中心</el-link></div>

                <div class="item"> <el-link :underline="false"
                           href="/price.html"
                           target="_blank">会员中心</el-link></div>

                <div class="sliver"></div>

                <div class="item"> <el-link :underline="false"
                           href="/index.html"
                           target="_blank">前往官网</el-link></div>

                <div class="item"> <el-link :underline="false"
                           @click="dowloadDialogVisible = true">下载APP</el-link></div>

                <div class="sliver"></div>

                <div class="item"> <el-link :underline="false"
                           @click="logout">退出登录</el-link></div>

              </div>
              <template #reference>
                <div class="avatar"> <el-avatar :size="48"
                             :src="userInfo.headPath"
                             class="defaultAvatar"></el-avatar>
                </div>
              </template>
            </el-popover>

            <div class="info"
                 v-if="!collapse">
              <div class="nickNmae">{{ userInfo.nickname }}</div>
              <div :class="'vip vip_' + vipInfo.vipLevel"></div>
            </div>
          </div>
          <div v-else
               class="userInfoContainer">
            <el-link :underline="false">
              <div class="toLogin"
                   @click="toLogin">去登录</div>
            </el-link>
          </div>
        </template>
      </div>

      <el-dialog :visible.sync="dowloadDialogVisible"
                 :append-to-body="true"
                 custom-class="dowloadContainer">
        <div class="qrcode"></div>
        <div class="desc">使用安卓手机扫码下载</div>
      </el-dialog>

    </div>
    <div class="openCloseContainer"
         v-if="from !== 'detail'">
      <el-link :underline="false"
               @click="openCloseMenU()"><span :class="'menu_open_close menu_' + collapse"></span></el-link>
    </div>
  </div>
</template>

<script>
import * as appJs from '../assets/js/app'
export default {
  props: ['random', 'type', 'from'],
  data () {
    return {
      userInfo: '',
      menuActiveIndex: '/',
      folderList: [],

      dowloadDialogVisible: false,
      vipInfo: {},
      collapse: true,
      curFolder: {
        name: ''
      }

    }
  },
  methods: {
    openCloseMenU () {
      this.collapse = !this.collapse
      localStorage.setItem('menu_collapse', this.collapse)
    },
    toLogin () {
      this.$store.commit('showLoginDialog');
    },
    toBuy () {
      let code = ''
      if (this.vipInfo.vipLevel === 'GOLD') {
        code = 3002
      }
      if (this.vipInfo.vipLevel === 'SLIVER') {
        code = 3003
      }
      this.$store.commit('showPriceDialog', code);
    },
    logout () {
      localStorage.removeItem('userInfo')
      localStorage.removeItem('Authorization')
      sessionStorage.clear()
      let _this = this
      this.axios.get('/webApi/v2/user/logout').then((response) => {
        _this.$message({
          message: '退出成功',
          type: 'success'
        })
        setTimeout(() => {
          _this.$router.go(0)
        }, 2000);
      })
    },
    to (path) {
      if (path.indexOf('userInfo') > -1) {
        let newpage = this.$router.resolve({ path: path })
        window.open(newpage.href, '_blank');
      } else {
        this.$router.push({ path: path })
      }
    },
    handleSelect (index) {
      if (index === this.$route.path) {
        return
      }
      this.$router.push({ path: index })
    },

    getUserInfo () {
      let _this = this
      this.axios.get('/webApi/v3/user/userInfo').then(resp => {
        _this.userInfo = resp.data
        localStorage.setItem('userInfo', JSON.stringify(resp.data))
      })
    }
  },
  computed: {
    userInfoRefreshFlag () {
      return this.$store.state.userInfoRefreshFlag
    }
  },
  watch: {
    userInfoRefreshFlag: function () {
      this.getUserInfo()
    }
  },
  beforeMount () {
    let path = this.$route.path
    if (path === '/chat') {
      this.collapse = true
      return
    }
    console.log(path)
    if (this.from === 'detail') {
      this.collapse = true
      return
    }
    if (localStorage.getItem('menu_collapse') === 'true') {
      this.collapse = true
    } else {
      this.collapse = false
    }
  },
  mounted () {
    let _this = this

    this.getUserInfo()

    _this.menuActiveIndex = _this.$route.path
    if (_this.$route.query.fid) {
      _this.menuActiveIndex = _this.menuActiveIndex + '?fid=' + _this.$route.query.fid
    }
    console.log(_this.menuActiveIndex)
    appJs.getVip().then(data => {
      _this.vipInfo = data
    })
  }
}
</script>
<style lang="less" scoped>
.menu_open_close {
  background-image: url('../assets/imgs/menu_open_close.png');
  width: 26px;
  height: 26px;
  display: inline-block;
  background-size: 100% auto;
  position: absolute;
  top: calc(50vh - 10px);
  right: 0px;
}

.openCloseContainer {
  display: inline-block;
  width: 20px;
  height: 100vh;

  .menu_open_close {
    display: none;
  }
}

.openCloseContainer:hover {
  .menu_open_close {
    display: block;
  }
}

.menu_false {
  background-position: bottom;
}

.menu_true {
}
</style>
<style lang="less" >
@import '../assets/css/index.less';

.dowloadContainer {
  width: 400px;
  height: 400px;
  border-radius: 20px;
  background-image: url('../assets/imgs/dowloadDilogBg.png');
  background-size: 100% 100%;

  .qrcode {
    width: 260px;
    height: 260px;
    background-image: url('../assets/imgs/download_qrcode.png');
    background-size: 100%;
    margin: auto;
  }

  .desc {
    margin-top: 10px;
    text-align: center;
    font-size: 18px;
  }
}

.left_menu_container {
  .goHome {
    position: absolute;
    bottom: 40px;
    left: 40px;
    padding: 10px;
    color: #3c4258;
  }

  .goHome::before {
    content: ' ';
    background-image: url('../assets/imgs/writepage_icon.png');
    height: 24px;
    width: 24px;
    background-position: 0px -550px;
    display: inline-block;
    vertical-align: middle;
    background-size: 200%;
  }

  .logo {
    background-image: url('../assets/imgs/icon_logo.png');
    width: 50px;
    height: 50px;
    background-size: 100%;
    vertical-align: middle;
    display: inline-block;
  }

  .title {
    margin-left: 10px;
    vertical-align: middle;
    display: inline-block;
    color: #383838;
    font-size: 26px;
    font-weight: 600;
  }

  .menu_item {
    text-align: left;
  }

  .menu_item::before {
    content: ' ';
    background-image: url('../assets/imgs/menu_icon.png');
    width: 25px;
    height: 25px;
    display: inline-block;
    vertical-align: middle;
    text-align: left;
    background-size: 400%;
  }

  .ai_writer::before {
    background-position: 0px 0px;
  }

  .userInfo::before {
    background-position: 0px -300px;
  }

  .orders::before {
    background-position: 0px -250px;
  }

  .ai_chat::before {
    background-position: 0px -50px;
  }

  .articles:before {
    background-position: 0px -100px;
  }

  .material:before {
    background-position: 0px -150px;
  }

  .recycle:before {
    background-position: 0px -200px;
  }

  .invoice:before {
    background-position: 0px -450px;
  }

  .is-active {
    color: white;
    border-radius: 10px;
    background-image: linear-gradient(
      to right,
      #3b88ea,
      #3c93f0,
      #3ca9fb,
      #3c90ee
    );

    .ai_writer::before {
      background-position: -50px 0px;
    }

    .userInfo::before {
      background-position: -50px -300px;
    }

    .orders::before {
      background-position: -50px -250px;
    }

    .ai_chat::before {
      background-position: -50px -50px;
    }

    .articles:before {
      background-position: -50px -100px;
    }

    .material:before {
      background-position: -50px -150px;
    }

    .recycle:before {
      background-position: -50px -200px;
    }

    .invoice:before {
      background-position: -50px -450px;
    }
  }

  .userInfoContainer {
    position: absolute;
    bottom: 10px;
    left: 20px;
    padding: 10px;

    .toLogin::before {
      content: ' ';
      width: 45px;
      height: 45px;
      background-image: url('../assets/imgs/defaultAvatar.png');
      display: inline-block;
      vertical-align: middle;
      background-size: 100%;
      margin-right: 15px;
    }

    .avatar {
      display: inline-block;
      vertical-align: middle;
    }

    .info {
      display: inline-block;
      vertical-align: middle;
      text-align: left;
      margin-left: 5px;

      .nickNmae {
        font-size: 17px;
      }

      .vip::before {
        color: #3c4258;
        font-size: 12px;
        border-radius: 5px;
        padding: 2px 5px;
        background-image: linear-gradient(to bottom, #f7f9fe, #f7f9fe);
        content: '免费版';
      }

      .vip_GOLD::before {
        background-image: linear-gradient(to bottom, #f0e1b8, #d4b380);
        content: '黄金VIP';
      }

      .vip_SILVER::before {
        background-image: linear-gradient(to bottom, #f7f7f7, #d5d8de);
        content: '白银VIP';
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/left_menu.vue